import Select from "react-select";
import { forwardRef, useEffect, useRef, useState } from "react";
import { InputTypes } from "../../data-parsing/InputTypes";
import { Editor } from "@tinymce/tinymce-react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import moment from "moment";
import ReactHtmlParser from "html-react-parser";
import RecipeName from "../../data-parsing/recipes/RecipeName";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import es_phone from "react-phone-number-input/locale/es";
import { DragAndDrop } from "../../data-parsing/recipes/DragAndDrop";
import { DragAndDropPrep } from "../../data-parsing/recipes/DragAndDropPrep"
import { parse } from "date-fns";
registerLocale("es", es);


/**
 * @alreylz
 * As far as I understand this component encapsulates Inputs of different types displaying one or other depending on props.type
 * (e.g., if something is a date, then it shows a Calendar, if it is a select, it shows a select with options... instead of needing different types of elements)
 * @param ref : allows the parent component to obtain a reference to the underlying input element
 * @see InputTypes 
*/
export const InputField = forwardRef((props, ref) => {
  const [padding, setPadding] = useState(0);
  const unitContainer = useRef();
  const [date, setDate] = useState(
    !isNaN(props.defaultValue)
      ? new Date(props.defaultValue * 1000)
      : new Date().setHours(0, 0, 0, 0)
  );
  const [value, setValue] = useState(
    props.defaultValue ? props.defaultValue : ""
  );

  useEffect(() => {
    setValue(props.defaultValue);
  }, [props.defaultValue]);

  function handleInputFocus(e) {
    setPadding(unitContainer.current?.getBoundingClientRect().width);
    e.target.select();
  }

  let defaultValue;
  if (props.type === InputTypes.SELECT) {
    defaultValue = props.options
      ?.map((a) => a.value)
      .includes(props.defaultValue)
      ? props.options?.filter((option) => {
        return option.value === props.defaultValue;
      })[0]
      : /*{
                label: props.defaultValue,
                value: props.defaultValue,
            }*/
      props.options && props.options[0];
  } else if (props.type === InputTypes.MULTIPLE_SELECT) {
    defaultValue = props.options?.filter((option) => {
      return props.defaultValue?.includes(option.value);
    });
  } else {
    defaultValue = props.defaultValue;
  }

  if (props.stringified) {
    try {
      return (
        <>{ReactHtmlParser(stringifyInput(defaultValue, props.type, props))}</>
      );
    } catch (e) {
      return stringifyInput(defaultValue, props.type, props);
    }
  }

  let styles;
  switch (props.type) {
    case InputTypes.SELECT:
      styles = {
        control: (base) => ({
          ...base,
          width: "100%",
          minWidth: "120px",
          tableLayout: "fixed",
        }),
        input: (base) => ({
          ...base,
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "auto",
          maxWidth: "100%",
        }),
      };
      //Using the default value as a key forces a remount when the value changes, so it gets updated
      return (
        <Select
          ref={ref}
          name={props.name}
          key={defaultValue}
          className="select2 select2-multiple "
          menuPosition="fixed"
          classNamePrefix="select2"
          {...props}
          isDisabled={props.readOnly}
          isClearable={false}
          styles={styles}
          placeholder="Selecciona uno..."
          defaultValue={defaultValue}
          options={props.options}
        />
      );
    case InputTypes.SELECT_WITH_PLACEHOLDER:
      styles = {
        control: (base) => ({
          ...base,
          width: "100%",
          minWidth: "120px",
          tableLayout: "fixed",
        }),
        input: (base) => ({
          ...base,
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "auto",
          maxWidth: "100%",
        }),
      };

      //console.log(props);
      //Using the default value as a key forces a remount when the value changes, so it gets updated
      return (
        <Select
          ref={ref}
          name={props.name}
          key={defaultValue}
          className="select2 select2-multiple "
          menuPosition="fixed"
          classNamePrefix="select2"
          {...props}
          isDisabled={props.readOnly}
          isClearable={false}
          styles={styles}
          placeholder="Selecciona uno..."
          defaultValue={defaultValue}
          options={props.options}
        />
      );
    case InputTypes.MULTIPLE_SELECT:
      styles = {
        control: (base) => ({
          ...base,
          width: "100%",
          height: "max-content",
          minWidth: "85 px",
          tableLayout: "fixed",
        }),
        dropdownIndicator: (base) => ({
          ...base,
          padding: "6px",
        }),
        input: (base) => ({
          ...base,
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "auto",
          maxWidth: "100%",
        }),
      };
      return (
        <Select
          ref={ref}
          name={props.name}
          className="select2 select2-multiple"
          classNamePrefix="select2"
          isMulti
          placeholder="Selecciona uno o más..."
          {...props}
          isClearable={false}
          styles={styles}
          isSearchable={true}
          isDisabled={props.readOnly}
          defaultValue={defaultValue}
          options={props.options}
        />
      );
    case InputTypes.NUMBER:
      return (
        <div style={{ position: "relative" }} key={props.defaultValue}>
          <input
            ref={ref}
            name={props.name}
            type="number"
            className="form-control"
            {...props}
            style={{ paddingRight: padding }}
            onFocus={(e) => handleInputFocus(e)}
            defaultValue={props.defaultValue ? props.defaultValue : 0}
          />
          {props.units && (
            <span ref={unitContainer} className="form-control-unit p-r-10">
              {props.units}
            </span>
          )}
        </div>
      );
    /*     case InputTypes.MONETARY_NUMBER: //Same case as number, but the number is money which comes as an int instead of decimal
      var monetaryNumber = props.defaultValue;

      monetaryNumber = String(monetaryNumber);

      const hasDecimals = monetaryNumber.includes(".");

      if (!hasDecimals && monetaryNumber) {
        monetaryNumber = (parseInt(monetaryNumber, 10) / 100).toFixed(2);
      } else if (hasDecimals) {
        const parts = monetaryNumber.split(".");

        if (parts[1].length > 2) {
          monetaryNumber = parseFloat(monetaryNumber).toFixed(2);
        }
      }

      return (
        <div style={{ position: "relative" }} key={monetaryNumber}>
          <input
            ref={ref}
            name={props.name}
            type="number"
            className="form-control"
            {...props}
            style={{ paddingRight: padding }}
            onFocus={(e) => handleInputFocus(e)}
            defaultValue={monetaryNumber}
          />
        </div>
      ); */
    case InputTypes.TELEPHONE_NUMBER:
      return (
        <PhoneInput
          international
          className={"form-control"}
          labels={es_phone}
          defaultCountry="ES"
          name={"telephone_number"}
          value={value}
          countrySelectProps={{ name: "" }}
          onChange={setValue}
        />
      );
    case InputTypes.DATE:

      console.log(` DATE ${date}`)
      return (
        <DatePicker
          className="form-control"
          selected={date}
          /*showTimeSelect*/
          value={date}
          customInput={<ExampleCustomInput />}
          dateFormat={props.format ? props.format : "dd/MM/yyyy"}
          locale="es"
          ref={ref}
          {...props}
          // onBlur={
          //   props?.doneEditing?.(true)

          // }


          onChange={(d) => {
            console.log(`Changed date to ${d} ${typeof d}`)
            setDate(d);

            console.log(props.setValue)
            //In case informe parent
            console.log("SET VALUE CALLED (informed parent)")

            props?.setValue?.(d /* Maybe required because the backend expects a timestamp?*/);
            props?.doneEditing?.(true)

            //if something subscribed to onChange
            props?.onChange?.(d);
          }}
        />
      );
    case InputTypes.RICH_TEXT_AREA:
      const tryParse = (string) => {
        try {
          return atob(string);
        } catch (e) {
          return string;
        }
      };
      const tryEncode = (string) => {
        try {
          return btoa(string);
        } catch (e) {
          return string;
        }
      };
      return (
        <>
          <input type={"hidden"} name={props.name} value={value} />
          <Editor
            ref={ref}
            id={"ignore" + (Math.random() * 100 + Math.random()).toString()}
            className="form-control"
            {...props}
            tinymceScriptSrc={
              process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
            }
            initialValue={tryParse(props.defaultValue)}
            value={tryParse(value)}
            onEditorChange={(newValue, editor) => {
              setValue(tryEncode(newValue));
            }}
            apiKey="qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc"
            init={{
              height: 300,
              zIndex: 0,
              promotion: false,
              branding: false,
              force_br_newlines: true,
              inline: !!props.inline,
              menubar: "file edit",
              toolbar:
                "undo redo | styleselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist ",
              style_formats: [
                { title: "Title text 1", block: "h1" },
                { title: "Title text 2", block: "h2" },
                { title: "Title text 3", block: "h3" },
                { title: "Title text 4", block: "h4" },
                { title: "Title text 5", block: "h5" },
                { title: "Title text 6", block: "h6" },
              ],
              plugins: [
                "advlist",
                "autolink",
                "lists",
                "link",
                "image",
                "charmap",
                "preview",
                "anchor",
                "searchreplace",
                "visualblocks",
                "code",
                "fullscreen",
                "nonbreaking",
                "insertdatetime",
                "media",
                "table",
                "code",
                "help",
                "wordcount",
              ],
              /*setup: editor => {
                                editor.on('init', function (e) {
                                    if(!!props.inline) {
                                        editor.execCommand('mceFocus');
                                    }
                                });

                            }*/
            }}
          />
        </>
      );
    case InputTypes.TEXT_AREA:
      return (
        <textarea
          ref={ref}
          className="form-control"
          style={{ resize: "vertical" }}
          placeholder="Completa..."
          {...props}
        />
      );


    case InputTypes.TEXT:
      return (
        <input
          ref={ref}
          name={props.name}
          type="text"
          className="form-control"
          placeholder="Completa..."
          {...props}
        />
      );
    case InputTypes.RECIPE_NAME:
      return <RecipeName {...props} />;
    case InputTypes.DRAG_AND_DROP_INGS:
      return <DragAndDrop {...props} />;
    case InputTypes.DRAG_AND_DROP_PREP:
      return <DragAndDropPrep {...props} />;
    default:
      return (
        <input
          ref={ref}
          name={props.name}
          type={props.type}
          className="form-control"
          {...props}
        />
      );
  }
});

const ExampleCustomInput = forwardRef((props, ref) => {
  const { name, ...rest } = props;

  console.log("ExampleCustom input props.value", props.value, typeof props.value)
  return (
    <>
      <input
        ref={ref}
        type={"hidden"}
        name={name}
        value={
          moment(props.value, "DD/MM/YYYY hh:mm").toDate().getTime() / 1000
        }
      />
      <input
        type="text"
        {...rest}
        style={{ textAlign: "left", whiteSpace: "nowrap" }}
      />
    </>
  );
});


/*This seems to */ 
function stringifyInput(value, type, props) {
  /*if(!value){
        return "";
    }*/
  let string = "";
  switch (type) {
    case InputTypes.SELECT:
      string += value?.label;
      return string;
    case InputTypes.MULTIPLE_SELECT:
      value?.forEach((element, index) => {
        string += element?.label;
        if (index < value.length - 1) {
          string += ",\n";
        }
      });
      return string;
    case InputTypes.RICH_TEXT_AREA:
      if (!value) {
        return "";
      }
      try {
        let parsed = atob(value);
        string += parsed;
      } catch (e) {
        string += value;
      }
      return string;
    case InputTypes.DATE:
      return (value && typeof value === "number")
        //when is passed as timestamp (a number)
        ? moment(new Date(value * 1000)).format(
          props.format ? props.format : "DD/MM/YYYY"
        )
        : value &&
        //When the value is a date itself
          value instanceof Date ? moment(value).format(
            props.format ? props.format : "DD/MM/YYYY"
          ) :
          "";
    case InputTypes.RECIPE_NAME:
      return <RecipeName stringified={true} {...props} />;

    case InputTypes.URL:
      return (value && typeof value === 'object' && typeof value.onClick === 'function')
        ? <button onClick={(ev) => {
          ev.stopPropagation()
          value.onClick()

        }}>{value.label ?? "ver"}</button>
        : (() => { console.warn("Missing required onClick for URL-type button") })();

    default:
      return "" + value;
  }
}
